import React from "react";
import { Badge, Tooltip } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useAccess } from "@umijs/max";
import { useChat } from "./ChatContext";
import styles from "../RightContent/index.less";

/**
 * Header action icon — mirrors NotificationBell/ConflictBell's Badge+icon
 * convention, but toggles the shared ChatWidget panel rather than owning its
 * own popover content (that content already lives in ChatPanel).
 */
const ChatBell: React.FC = () => {
  const { ready, unreadTotal, open, toggleOpen } = useChat();
  const access = useAccess();
  if (!ready || !access.canViewChat) return null;

  return (
    <Tooltip title="Chat">
      <span className={styles.action} style={{ cursor: "pointer" }} onClick={toggleOpen}>
        <Badge count={unreadTotal} overflowCount={99} size="small">
          <MessageOutlined style={{ fontSize: 18, color: open ? "#1890ff" : "#fff" }} />
        </Badge>
      </span>
    </Tooltip>
  );
};

export default ChatBell;
